import React from 'react';

import {func} from 'prop-types';

import ActionsPanelItem from '../../components/ActionsPanelItem';

import classes from './ActionInsert.module.css';

const SystemItemActionInsert = ({
    onToggleCreateSensorModal,
    onToggleCreateSystemEquipmentModal,
    onToggleDeleteSystemModal,
    onToggleEditSystemModal
}) => (
    <div className={classes.agentActions}>
        <ActionsPanelItem
            title="Edit System"
            iconUrl="/assets/images/systemTreeIcon.svg"
            onClick={() => onToggleEditSystemModal(true)}
        />
        <ActionsPanelItem
            title="Add Equipment to System"
            iconUrl="/assets/images/equipmentTreeIcon.svg"
            onClick={() => onToggleCreateSystemEquipmentModal(true)}
        />
        <ActionsPanelItem
            title="Add Sensor to System"
            iconUrl="/assets/images/sensorTreeIcon.svg"
            onClick={() => onToggleCreateSensorModal(true)}
        />
        <ActionsPanelItem
            title="Delete System"
            iconUrl="/assets/images/deleteIconColor.svg"
            onClick={() => onToggleDeleteSystemModal(true)}
        />
    </div>
);

SystemItemActionInsert.defaultProps = {
    onToggleCreateSensorModal:    () => {},
    onToggleDeleteEquipmentModal: () => {},
    onToggleEditSystemModal:      () => {}
};

SystemItemActionInsert.propTypes = {
    onToggleCreateSensorModal:    func,
    onToggleDeleteEquipmentModal: func,
    onToggleEditSystemModal:      func
};

export default SystemItemActionInsert;
